var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-confirmed-attendance",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-confirmed-attendance:not(.animated) .animable {opacity: 0;}svg#freepik_stories-confirmed-attendance.animated #freepik--background-complete--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-confirmed-attendance.animated #freepik--Shadow--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}svg#freepik_stories-confirmed-attendance.animated #freepik--Plant--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-confirmed-attendance.animated #freepik--Device--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-confirmed-attendance.animated #freepik--speech-bubble--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-confirmed-attendance.animated #freepik--Character--inject-19 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomIn;animation-delay: 0s;}            @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomIn {                0% {                    opacity: 0;                    transform: scale(0.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-19",
    className: "animable",
    style: {
      transformOrigin: "250px 228.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "eleb0pay2pnq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elr90lwbjy61k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "ely1mp7flxs7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "els9m5vg9tqt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "el3nxz3avurw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "elmvbt65el7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "el975u9iqar18",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "el3lv9ttly3ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elhyx8nn3cdjv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.05,
    y: 113.72,
    width: 5.24,
    height: 110.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "418.67px 168.805px"
    },
    id: "el7gttimgf1kn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli9ql7f2gxi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.64,
    y: 113.72,
    width: 99.62,
    height: 110.17,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "368.45px 168.805px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhhu3ltgu6f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.46,
    y: 113.72,
    width: 103.32,
    height: 110.17,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.12px 168.805px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6vm5i8xf9h9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.83,
    y: 117.24,
    width: 94.74,
    height: 101.6,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.2px 168.04px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely09rwevq0of"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.83,
    y: 117.24,
    width: 2.74,
    height: 101.6,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "321.2px 168.04px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elw9e3o19ajl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.18,
    y: 145.4,
    width: 2.74,
    height: 92.54,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "368.55px 191.67px",
      transform: "rotate(-90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elu1n9to62mrs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.83,
    y: 185.7,
    width: 96.21,
    height: 4.6,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "367.935px 188px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 66.4,
    y: 183.07,
    width: 156.54,
    height: 198.22,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "144.67px 282.18px"
    },
    id: "el1ywxb1qud4u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 190.3,
    width: 145.47,
    height: 42.39,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "144.675px 211.495px"
    },
    id: "elgwthnmlxxit",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 197.16,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "76.07px 214.92px"
    },
    id: "elwd9j0h7ynu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.89,
    y: 197.16,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "116.02px 214.92px"
    },
    id: "elxep0axg4wj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzpssokokas"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.33,
    y: 196.72,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "164.46px 214.48px",
      transform: "rotate(-9.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 82.17,
    y: 201.84,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.3px 217.26px"
    },
    id: "elucff6to911",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.17,
    y: 201.84,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "105.3px 217.26px"
    },
    id: "elasou8mkjvu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.11,
    y: 201.84,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "153.24px 217.26px"
    },
    id: "eldv0xu2zkpw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltt2aq4xhrl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126.19,
    y: 201.31,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "130.32px 216.73px",
      transform: "rotate(-12.53deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 93.45,
    y: 195.4,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "95.515px 214.045px"
    },
    id: "el38vmrwb0yhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.6,
    y: 195.4,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "144.665px 214.045px"
    },
    id: "el1rr0xxy5ty1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzvl1xakg7jf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 239.4,
    width: 145.47,
    height: 42.39,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "144.675px 260.595px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwp3a0b8p7f8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 209.14,
    y: 246.26,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "213.27px 264.02px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaeun04pzrs"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.18,
    y: 246.26,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "173.31px 264.02px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el9amubizi1jm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.75,
    y: 245.82,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "124.88px 263.58px",
      transform: "rotate(-170.256deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elo2zuu90hws"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.9,
    y: 250.94,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "203.03px 266.36px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbf2477pbp3w"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.91,
    y: 250.94,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "184.04px 266.36px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elk175oqxwdx"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 131.97,
    y: 250.94,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "136.1px 266.36px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eloaqrq7b52d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.89,
    y: 250.41,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "159.02px 265.83px",
      transform: "rotate(-167.47deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgjw4wg006to"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.76,
    y: 244.5,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "193.825px 263.145px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elu5epzgdvkvj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.6,
    y: 244.5,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "144.665px 263.145px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 246.26,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "76.07px 264.02px"
    },
    id: "elo6c5eiw0a1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.17,
    y: 250.94,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "86.3px 266.36px"
    },
    id: "elrbf3ubjooi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.17,
    y: 250.94,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "105.3px 266.36px"
    },
    id: "elvwo1jrunbrs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.45,
    y: 244.5,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "95.515px 263.145px"
    },
    id: "elaic5wrjxpbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.94,
    y: 288.5,
    width: 145.47,
    height: 42.39,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "144.675px 309.695px"
    },
    id: "ellyywf8skcq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.43,
    y: 295.36,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "159.56px 313.12px"
    },
    id: "el4vwwq9fi0p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkmhb516n9mj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.87,
    y: 294.91,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "208px 312.67px",
      transform: "rotate(-9.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 125.71,
    y: 300.04,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "129.84px 315.46px"
    },
    id: "elzi0mdggbf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.71,
    y: 300.04,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.84px 315.46px"
    },
    id: "ela0frp11wylw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.65,
    y: 300.04,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "196.78px 315.46px"
    },
    id: "elqj3bhp2ovzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elirmooqal69f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.73,
    y: 299.51,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "173.86px 314.93px",
      transform: "rotate(-12.53deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 136.99,
    y: 293.59,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "139.055px 312.235px"
    },
    id: "elqbw4v3j9gl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.14,
    y: 293.59,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "188.205px 312.235px"
    },
    id: "el6dqzna2vj7l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsrh2upwwqyd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 294.91,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "112.93px 312.67px",
      transform: "rotate(-9.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 97.58,
    y: 300.04,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "101.71px 315.46px"
    },
    id: "el68ixk1bcpj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm60zspqrjth"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.66,
    y: 299.51,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "78.79px 314.93px",
      transform: "rotate(-12.53deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 91.07,
    y: 293.59,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "93.135px 312.235px"
    },
    id: "elg3kibqs12",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55,263h88.21a17.32,17.32,0,0,1,17.33,17.32v68.89H301.22V280.3A17.32,17.32,0,0,1,318.55,263Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "362.655px 306.105px"
    },
    id: "el693ml7f1l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.14,314h15.79a10.3,10.3,0,0,1,10.29,10.3v57H264.85v-57A10.3,10.3,0,0,1,275.14,314Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "283.035px 347.65px"
    },
    id: "el0rk2ybsjznmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.14,314h.34a10.3,10.3,0,0,1,10.29,10.3v57H264.85v-57A10.3,10.3,0,0,1,275.14,314Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "275.31px 347.65px"
    },
    id: "elenxicbvc3kg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.18,
    y: 355.13,
    width: 121.06,
    height: 26.17,
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "350.71px 368.215px"
    },
    id: "elje1540ljuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.54,
    y: 331.19,
    width: 137.69,
    height: 27.45,
    rx: 10.47,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "348.385px 344.915px"
    },
    id: "elbe35rwdhsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.62,
    y: 331.19,
    width: 35.41,
    height: 27.45,
    rx: 10.47,
    style: {
      fill: "rgb(224, 224, 224)",
      isolation: "isolate",
      transformOrigin: "399.325px 344.915px"
    },
    id: "eliamuez247g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,314h15.78a10.3,10.3,0,0,1,10.3,10.3v57H397.83v-57A10.3,10.3,0,0,1,408.13,314Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "416.02px 347.65px"
    },
    id: "elzij2asyiklk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.13,314h.33a10.3,10.3,0,0,1,10.3,10.3v57H397.83v-57A10.3,10.3,0,0,1,408.13,314Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "408.295px 347.65px"
    },
    id: "elkquav4zj3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eln6ug9zalp3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.74,
    cy: 136.74,
    r: 23.55,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.74px 136.74px",
      transform: "rotate(-9.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4znmmhazt7p"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146.74,
    cy: 136.74,
    r: 20.03,
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "146.74px 136.74px",
      transform: "rotate(-9.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "145.79 150.48 145.79 136.48 136.51 141.73",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "141.15px 143.48px"
    },
    id: "elpumbr25dli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,151.48a1,1,0,0,1-1-1V138.19L137,142.6a1,1,0,0,1-1.37-.38,1,1,0,0,1,.38-1.36l9.28-5.25a1,1,0,0,1,1.49.87v14A1,1,0,0,1,145.79,151.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "141.141px 143.481px"
    },
    id: "el0atljbjzjngc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-19",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-19",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-19",
    className: "animable",
    style: {
      transformOrigin: "119.946px 345.138px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120,383.88h0a.38.38,0,0,1-.32-.41c0-.07.06-.78.11-2,.1-1.85.25-5.73.2-10.92a1.48,1.48,0,0,0,0-.22c-.07-5.79-.38-11.5-.92-17-.5-5.09-1.22-10-2.13-14.7a120.72,120.72,0,0,0-3-11.89v0h0c-.18-.57-.37-1.15-.56-1.72s-.31-.94-.48-1.41c-.42-1.22-.81-2.38-1.14-3.46-.75-2.38-1.41-4.75-2-7.06-.34-1.38-.63-2.74-.89-4a89.28,89.28,0,0,1-1.69-15c-.05-2,0-4,.09-5.87a57.77,57.77,0,0,1,.64-6c0-.15,0-.28.07-.4l0-.19a.35.35,0,0,1,.1-.25.37.37,0,0,1,.52,0,.42.42,0,0,1,.11.37h0l0,.19-.06.41a55.9,55.9,0,0,0-.64,5.92c-.1,1.89-.13,3.85-.08,5.81a87,87,0,0,0,1.68,14.85c.24,1.29.54,2.64.87,4,.55,2.29,1.2,4.65,2,7,.33,1.07.71,2.23,1.13,3.44.17.47.33.94.49,1.42s.37,1.15.55,1.72l0,0h0a118.88,118.88,0,0,1,3,12c.92,4.68,1.64,9.65,2.14,14.77.55,5.48.86,11.21.93,17a2.25,2.25,0,0,1,0,.26c.06,5.18-.1,9.08-.19,10.93-.06,1.26-.11,2-.12,2.08A.36.36,0,0,1,120,383.88Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.947px 332.578px"
    },
    id: "elc78aev19wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,281.74s0,0,0,0h0a10.75,10.75,0,0,1,4.58-2.65",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "110.65px 280.415px"
    },
    id: "elcn79zprmk2t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.36,282.1l-.15,0a.37.37,0,0,1-.19-.48.28.28,0,0,1,.08-.11l0,0h0a11.2,11.2,0,0,1,4.74-2.73.37.37,0,0,1,.46.25.38.38,0,0,1-.26.46,10.54,10.54,0,0,0-2.47,1.05,10.82,10.82,0,0,0-2,1.5h0A.36.36,0,0,1,108.36,282.1Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "110.652px 280.432px"
    },
    id: "elgjqrwt14c0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,288.59a.36.36,0,0,1-.24-.09l-2.47-2.05a.37.37,0,0,1-.05-.52.37.37,0,0,1,.52,0l2.47,2.05a.36.36,0,0,1,0,.51A.37.37,0,0,1,107.64,288.59Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "106.386px 287.207px"
    },
    id: "elaepz0r38wve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.07,320.43a.39.39,0,0,1-.37-.38h0a9.29,9.29,0,0,1,.5-2,9.91,9.91,0,0,1,2.84-4.15.37.37,0,0,1,.52,0,.37.37,0,0,1,0,.52,10.06,10.06,0,0,0-1.37,1.48,9.06,9.06,0,0,0-1.26,2.38,8.32,8.32,0,0,0-.46,1.78.33.33,0,0,1-.35.35Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.683px 317.112px"
    },
    id: "eldrj1lotrn3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.26,327a.39.39,0,0,1-.34-.22,6.14,6.14,0,0,0-3.66-3.31.37.37,0,0,1,.23-.7,6.92,6.92,0,0,1,4.1,3.71.36.36,0,0,1-.18.48A.28.28,0,0,1,114.26,327Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "112.33px 324.88px"
    },
    id: "elv42t8qqa5wg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85,359.69c-.84-.92-1.6-4.55-2-6.5-.1-.46-.18-.86-.25-1.15",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "118.725px 355.865px"
    },
    id: "elgm8stv0j65s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.85,360.06a.36.36,0,0,1-.27-.12c-.84-.92-1.52-3.93-2.1-6.67-.1-.46-.18-.86-.25-1.14a.37.37,0,0,1,.28-.44.36.36,0,0,1,.44.27c.07.29.15.69.25,1.16.37,1.78,1.15,5.48,1.92,6.33a.37.37,0,0,1,0,.52A.38.38,0,0,1,119.85,360.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "118.724px 355.87px"
    },
    id: "el6qpbvstw3jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.12,313.4a.36.36,0,0,1-.36-.34c-.05-.6-1-14.75,6.82-20.41a.37.37,0,0,1,.51.08.36.36,0,0,1-.08.51c-7.47,5.42-6.53,19.62-6.52,19.76a.38.38,0,0,1-.34.4Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.431px 302.991px"
    },
    id: "ele6z7ix5sma7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,344.18c-.9,3.42,6.67,9.54,6.67,9.54s9.59-1.63,10.49-5.06-1.79-8.85-6.53-10.09S111.67,340.75,110.77,344.18Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "119.399px 346.015px"
    },
    id: "elv7qwxji8jgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.89,303.5c1.08,3.55,8.09,5.8,8.09,5.8s4.57-5.78,3.48-9.33-5.06-7.33-8.26-6.36S99.81,300,100.89,303.5Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "106.565px 301.378px"
    },
    id: "ellnap59ytehs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.58,314.2a9.31,9.31,0,0,1-2.89,1.81,3.14,3.14,0,0,1-3.19-.61c-1-1-.8-2.69-.27-4,1-2.61,5.12-7.12,8.46-6C126.5,307,121.62,312.55,119.58,314.2Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "118.267px 310.715px"
    },
    id: "el55n7mymhmj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.17,321.13c.66.74,1.36,1.68,1.06,2.63a2,2,0,0,1-2.13,1.16,5.68,5.68,0,0,1-2.39-1c-1.73-1.09-5.26-3.37-3.17-5.74S108.79,319.56,110.17,321.13Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.1px 321.179px"
    },
    id: "el9k3l6gcicvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73,288.11a1.72,1.72,0,0,1,1.62,1.2c.18.82-.48,1.58-1.12,2.12-1.6,1.35-6.44,5-7.7,1.74C114.34,290.07,120.52,288,122.73,288.11Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "119.88px 291.297px"
    },
    id: "elxwclc5atzlo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06,277.56c1,.05,2-.36,3.08-.34s2.21.8,2,1.81-1.32,1.31-2.27,1.41a19,19,0,0,1-4.88-.12,1.54,1.54,0,0,1-1-.46c-.44-.6.19-1.45.89-1.7a10,10,0,0,0,2.13-.6Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "114.005px 278.881px"
    },
    id: "elxo0ci2nw9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,285.08c-1,.08-2.06-.32-3.09-.28s-2.2.85-2,1.87,1.34,1.27,2.3,1.35a18.49,18.49,0,0,0,4.87-.23,1.5,1.5,0,0,0,1-.47c.43-.61-.22-1.45-.92-1.68a10.14,10.14,0,0,1-2.15-.56Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "102.373px 286.442px"
    },
    id: "elgufpj01jac7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.07,283.11h0a.37.37,0,0,1-.34-.39c.15-2-.07-3.94-.45-4.05a.37.37,0,0,1-.25-.46.38.38,0,0,1,.46-.25c1.16.34,1.07,3.48,1,4.81A.38.38,0,0,1,108.07,283.11Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.771px 280.53px"
    },
    id: "elt3bnrqizrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.75,278.4a8.79,8.79,0,0,0-2.7-3.66c-1.28-.85-3.27-.83-4.12.45-1,1.43.15,3.49,1.73,4.16s3.39.37,5.07.06c0-.25,0-.51,0-.76Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "105.153px 276.955px"
    },
    id: "el3i2ali5lkti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.13,396.26h-.07a.36.36,0,0,1-.29-.43c2.46-13.12,9.93-18.85,10-18.91a.37.37,0,0,1,.52.08.36.36,0,0,1-.08.51c-.07.05-7.32,5.63-9.72,18.46A.37.37,0,0,1,121.13,396.26Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "126.062px 386.554px"
    },
    id: "el4gkuvpuloo6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.85,379.64a.35.35,0,0,1-.34-.24.36.36,0,0,1,.21-.47,8.06,8.06,0,0,1,3.86-.14.39.39,0,0,1,.31.43.38.38,0,0,1-.43.3,7.5,7.5,0,0,0-3.48.1A.3.3,0,0,1,128.85,379.64Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "130.689px 379.13px"
    },
    id: "elcyk3gaw9yn5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.19,381.7a.37.37,0,0,1-.36-.35,16,16,0,0,1,2.51-9.08.36.36,0,0,1,.51-.09.37.37,0,0,1,.1.51,15.48,15.48,0,0,0-2.39,8.62.37.37,0,0,1-.35.39Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "128.417px 376.906px"
    },
    id: "eltajirprr59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.57,386a.36.36,0,0,1-.26-.11.35.35,0,0,1,0-.51,5.19,5.19,0,0,1,5.08-1.24.37.37,0,1,1-.22.7,4.49,4.49,0,0,0-4.33,1.05A.38.38,0,0,1,124.57,386Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "126.948px 384.963px"
    },
    id: "eldx15yjqavcw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.22,389a.35.35,0,0,1-.33-.21,12.1,12.1,0,0,1-.78-6.21.36.36,0,0,1,.41-.32.36.36,0,0,1,.32.41,11.59,11.59,0,0,0,.71,5.81.37.37,0,0,1-.17.49A.45.45,0,0,1,123.22,389Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "122.791px 385.628px"
    },
    id: "els0l1kgsf79q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.88,391.93c0,.06-.27.34.78.41,2.59.17,7.16.12,8.81-2.08,2.36-3.13-3.29-3-2.79-4.73s6.62-.16,7.73-2.65-3.29-2.1-3.13-3.39,4.85.5,6.3-2.13-2.55-1.3-1.93-2.39,5.63-5.57,3.52-6.65-6.81,3.61-8.38,4.08-2.09-4.25-4.14-2.72-.46,8.67-2.88,9.5c-1.8.61-.88-1.92-3.12-1.88C119.6,377.36,118.89,387.31,121.88,391.93Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "130.826px 380.28px"
    },
    id: "el22fi4q81xjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el041793srijbd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "130.826px 380.28px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.88,391.93c0,.06-.27.34.78.41,2.59.17,7.16.12,8.81-2.08,2.36-3.13-3.29-3-2.79-4.73s6.62-.16,7.73-2.65-3.29-2.1-3.13-3.39,4.85.5,6.3-2.13-2.55-1.3-1.93-2.39,5.63-5.57,3.52-6.65-6.81,3.61-8.38,4.08-2.09-4.25-4.14-2.72-.46,8.67-2.88,9.5c-1.8.61-.88-1.92-3.12-1.88C119.6,377.36,118.89,387.31,121.88,391.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "130.826px 380.28px"
    },
    id: "eljzxb19roq6q",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M120.85,396.58a.37.37,0,0,1-.36-.28A40,40,0,0,0,110,378.45a.37.37,0,1,1,.49-.55,40.88,40.88,0,0,1,10.7,18.22.36.36,0,0,1-.26.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "115.525px 387.181px"
    },
    id: "el1a09r8o0v6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,383.73h-.07l-.08,0h-.05a10,10,0,0,0-4-.61.38.38,0,0,1-.39-.35.36.36,0,0,1,.35-.38,10.73,10.73,0,0,1,4.31.65l0,0a.36.36,0,0,1-.11.71Zm.11-.71.07,0Zm0,0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "112.321px 383.063px"
    },
    id: "eluj8q9mjzubs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,385.53h0a.37.37,0,0,1-.35-.39,13.39,13.39,0,0,0-2.12-7.56.38.38,0,0,1,.09-.51.36.36,0,0,1,.51.09,13.92,13.92,0,0,1,2.25,8A.36.36,0,0,1,115.91,385.53Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "114.837px 381.266px"
    },
    id: "el8vun4ek3q8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,387.93a.39.39,0,0,1-.25-.1,4,4,0,0,0-3.8-.76.37.37,0,0,1-.22-.71,4.79,4.79,0,0,1,4.52.93.37.37,0,0,1-.25.64Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "115.368px 387.038px"
    },
    id: "el4xexhhy7m6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.44,391.9a.45.45,0,0,1-.16,0,.37.37,0,0,1-.17-.49,10.22,10.22,0,0,0,.61-5.12.37.37,0,0,1,.32-.41.36.36,0,0,1,.41.32,10.6,10.6,0,0,1-.68,5.52A.35.35,0,0,1,119.44,391.9Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "119.816px 388.892px"
    },
    id: "elyy97lunopt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,394.72c-2,.13-5.5-1.58-6.92-3.33s2.44-.8,2-2.22-5.12-.15-6.08-2.17,2.46-1.7,2.28-2.75-3.7-.68-4.93-2.82,1.93-1.05,1.4-1.94-4.58-4.53-3-5.4,5.41,3,6.65,3.34,1.41-2.37,3.06-1.12.7,7,2.61,7.72c1.42.5.71-2.11,2.34-1.51C122.91,383.56,121.46,394.67,120.65,394.72Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "113.391px 384.345px"
    },
    id: "el4kguejxn45h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el26d9is93e2d"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "113.391px 384.345px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.65,394.72c-2,.13-5.5-1.58-6.92-3.33s2.44-.8,2-2.22-5.12-.15-6.08-2.17,2.46-1.7,2.28-2.75-3.7-.68-4.93-2.82,1.93-1.05,1.4-1.94-4.58-4.53-3-5.4,5.41,3,6.65,3.34,1.41-2.37,3.06-1.12.7,7,2.61,7.72c1.42.5.71-2.11,2.34-1.51C122.91,383.56,121.46,394.67,120.65,394.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "113.391px 384.345px"
    },
    id: "elsakeuj8dxe",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,398.6c0,9.68,4.27,17.52-17.53,17.52-19.37,0-17.52-7.84-17.52-17.52s7.84-12.42,17.52-12.42S136.6,388.92,136.6,398.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.22px 401.15px"
    },
    id: "ellh171ea0xu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.7,
    y: 385.99,
    width: 38.8,
    height: 9.6,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.1px 390.79px"
    },
    id: "el6dcwk280u27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcth8554e945"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.7,
    y: 385.99,
    width: 38.8,
    height: 9.6,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "119.1px 390.79px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-19",
    className: "animable",
    style: {
      transformOrigin: "313.02px 270.715px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.18,
    y: 125.31,
    width: 161.68,
    height: 290.81,
    rx: 9.69,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "313.02px 270.715px"
    },
    id: "elakd01676hqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elniz5lcbqljl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.18,
    y: 125.31,
    width: 161.68,
    height: 290.81,
    rx: 9.69,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "313.02px 270.715px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elasqgclxngeo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313,131.76a2.07,2.07,0,1,1-2.06-2.07A2.06,2.06,0,0,1,313,131.76Z",
    style: {
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "310.93px 131.76px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ell4ijrjeilj7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.18,131.76a1.33,1.33,0,1,1-1.32-1.32A1.33,1.33,0,0,1,317.18,131.76Z",
    style: {
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "315.85px 131.77px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,135.06v270.8a4,4,0,0,1-4,4H241.22a3.55,3.55,0,0,1-3.59-3.63V134.73a3.2,3.2,0,0,1,3.08-3.32H276.5a2.51,2.51,0,0,1,2.3,1.61l1.49,3.65a2.5,2.5,0,0,0,2.3,1.59h60.94a2.5,2.5,0,0,0,2.3-1.57l1.48-3.67a2.53,2.53,0,0,1,2.31-1.61h35.27A3.61,3.61,0,0,1,388.41,135.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "313.019px 270.635px"
    },
    id: "elg3rv04on1i8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elci0djg3a0vl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.63,
    y: 148.32,
    width: 150.77,
    height: 243.54,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      isolation: "isolate",
      transformOrigin: "313.015px 270.09px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 179.77,
    width: 143.33,
    height: 208.66,
    style: {
      fill: "rgb(64, 123, 255)",
      isolation: "isolate",
      transformOrigin: "313.015px 284.1px"
    },
    id: "elq8xq5jqyg6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela13rysatc89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 179.77,
    width: 143.33,
    height: 208.66,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "313.015px 284.1px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.21,403.2h-2.38a2.27,2.27,0,0,1-2.27-2.26v-2.38a2.27,2.27,0,0,1,2.27-2.27h2.38a2.27,2.27,0,0,1,2.27,2.27v2.38A2.27,2.27,0,0,1,314.21,403.2Zm-2.38-6a1.34,1.34,0,0,0-1.33,1.34v2.38a1.34,1.34,0,0,0,1.33,1.33h2.38a1.34,1.34,0,0,0,1.33-1.33v-2.38a1.34,1.34,0,0,0-1.33-1.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.02px 399.745px"
    },
    id: "elshkwypiqse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.02,
    cy: 241.65,
    r: 42.02,
    style: {
      fill: "rgb(64, 123, 255)",
      isolation: "isolate",
      transformOrigin: "313.02px 241.65px"
    },
    id: "elgq0vzqo4izw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,280.87a39.23,39.23,0,1,1,39.22-39.22A39.26,39.26,0,0,1,313,280.87Zm0-74.72a35.5,35.5,0,1,0,35.5,35.5A35.54,35.54,0,0,0,313,206.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "312.99px 241.64px"
    },
    id: "elomrxu9u533",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.61,260.42a3.84,3.84,0,0,1-2.94-1.37l-16.49-19.42a3.86,3.86,0,0,1,5.89-5l13.54,16L331,224.24a3.86,3.86,0,0,1,5.89,5l-25.31,29.81A3.84,3.84,0,0,1,308.61,260.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.037px 241.649px"
    },
    id: "elfm1zbbp2hl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.35,
    y: 153.1,
    width: 143.33,
    height: 24.56,
    style: {
      fill: "rgb(64, 123, 255)",
      isolation: "isolate",
      transformOrigin: "313.015px 165.38px"
    },
    id: "ele0ybmrrt4js",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,161.19a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,377.77,161.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "376.67px 161.19px"
    },
    id: "el0pyvrm44ibr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,165.38a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,377.77,165.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "376.67px 165.38px"
    },
    id: "el5vbtyt5zpko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.77,169.57a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,377.77,169.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "376.67px 169.57px"
    },
    id: "el1lhyvnfe1hg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.81,168.43h-3.37l-.66,1.56h-1.29l3-6.73h1.23l3,6.73h-1.31Zm-.42-1-1.27-2.94-1.26,2.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.105px 166.625px"
    },
    id: "el1m253l6svrg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.67,164.31h-2.23v-1.05h5.71v1.05h-2.23V170h-1.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.295px 166.63px"
    },
    id: "elkp2uf1r0vtn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.55,164.31h-2.23v-1.05H297v1.05H294.8V170h-1.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "294.16px 166.63px"
    },
    id: "eljuk7pma6eq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,168.94V170h-5v-6.73h4.91v1h-3.66v1.75h3.25v1h-3.25v1.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "300.5px 166.635px"
    },
    id: "elaq2v7hdwz8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.39,163.26V170h-1l-3.71-4.56V170h-1.24v-6.73h1l3.71,4.55v-4.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "307.415px 166.63px"
    },
    id: "el7covhx7xvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.2,163.26h2.94a3.38,3.38,0,1,1,0,6.73H312.2Zm2.88,5.67a2.32,2.32,0,1,0,0-4.62h-1.63v4.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.519px 166.625px"
    },
    id: "elegqses4rl4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.41,168.43H321l-.66,1.56h-1.29l3-6.73h1.23l3,6.73h-1.31Zm-.42-1-1.27-2.94-1.26,2.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "322.665px 166.625px"
    },
    id: "elrm5upouk5yn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.22,163.26V170h-1l-3.71-4.56V170h-1.24v-6.73h1l3.71,4.55v-4.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "330.245px 166.63px"
    },
    id: "elf8grgweuae4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.54,166.62a3.43,3.43,0,0,1,3.61-3.46,3.39,3.39,0,0,1,2.66,1.12l-.8.76a2.39,2.39,0,0,0-1.8-.78,2.37,2.37,0,1,0,0,4.73,2.34,2.34,0,0,0,1.8-.8l.8.77a3.65,3.65,0,0,1-6.27-2.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "337.675px 166.615px"
    },
    id: "elslom71jiwbg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,168.94V170H342v-6.73h4.92v1h-3.67v1.75h3.25v1h-3.25v1.86Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "344.53px 166.635px"
    },
    id: "el5xnct1eec6m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.18,293.39a4.23,4.23,0,0,1,7.28-2.72l-.94.89a2.73,2.73,0,0,0-2.09-.92,2.75,2.75,0,1,0,0,5.5,2.74,2.74,0,0,0,2.09-.93l.94.89a4.23,4.23,0,0,1-7.28-2.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.82px 293.385px"
    },
    id: "elfw5ouorouc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.13,293.39a4.22,4.22,0,1,1,4.22,4A4,4,0,0,1,285.13,293.39Zm7,0a2.75,2.75,0,1,0-2.74,2.75A2.66,2.66,0,0,0,292.09,293.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "289.344px 293.173px"
    },
    id: "elmy10805v6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.05,289.48v7.82h-1.19l-4.32-5.3v5.3H295.1v-7.82h1.2l4.31,5.29v-5.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.575px 293.39px"
    },
    id: "el7d0ajsrhfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,290.7v2.38h3.77v1.22h-3.77v3h-1.45v-7.82h5.7v1.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "307.01px 293.39px"
    },
    id: "el1wepwzh2jag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.28,289.48h1.45v7.82h-1.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.005px 293.39px"
    },
    id: "el7zyzc58z6z9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,297.3l-1.6-2.29h-2.07v2.28h-1.45v-7.82h3.22c2.05,0,3.33,1,3.33,2.78a2.51,2.51,0,0,1-1.67,2.47l1.8,2.57Zm-2-6.59h-1.7v3.11H318c1.27,0,1.93-.58,1.93-1.56S319.26,290.71,318,290.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.22px 293.385px"
    },
    id: "elj20qprdl3y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.19,297.3v-5.18l-2.57,4.28H327l-2.56-4.22v5.12H323v-7.82h1.2l3.1,5.18,3.05-5.18h1.19l0,7.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.27px 293.39px"
    },
    id: "eljfbjux04b9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.55,296.08v1.22h-5.87v-7.82h5.71v1.22h-4.25v2h3.77v1.19h-3.77v2.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.615px 293.39px"
    },
    id: "elfhwk6kn3zuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.17,289.48h3.42c2.53,0,4.27,1.56,4.27,3.91s-1.74,3.91-4.27,3.91h-3.42Zm3.35,6.59a2.69,2.69,0,1,0,0-5.36h-1.9v5.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.015px 293.39px"
    },
    id: "elc8rgm0r99bt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.08,320.32H378a4.4,4.4,0,0,1,4.4,4.4v63.71a0,0,0,0,1,0,0H243.69a0,0,0,0,1,0,0V324.71A4.4,4.4,0,0,1,248.08,320.32Z",
    style: {
      fill: "rgb(64, 123, 255)",
      isolation: "isolate",
      transformOrigin: "313.045px 354.375px"
    },
    id: "el1psf6mo7k5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8ttr97g1lxc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.08,320.32H378a4.4,4.4,0,0,1,4.4,4.4v63.71a0,0,0,0,1,0,0H243.69a0,0,0,0,1,0,0V324.71A4.4,4.4,0,0,1,248.08,320.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "313.045px 354.375px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0gchc00hx7vp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.75,347.77a19.55,19.55,0,0,1-7.42,15.36,3,3,0,0,1-.34.28,19.11,19.11,0,0,1-4.2,2.44,19.5,19.5,0,0,1-11.29,1.23A5.17,5.17,0,0,1,264,367a14.79,14.79,0,0,1-1.82-.48,19.16,19.16,0,0,1-5.37-2.68c-.18-.12-.34-.24-.51-.37a19.64,19.64,0,1,1,31.49-15.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "268.15px 347.794px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,366.48a18.31,18.31,0,0,1-3.43-.31,4.45,4.45,0,0,1-.48-.1,17.57,17.57,0,0,1-1.77-.46,18.07,18.07,0,0,1-5.12-2.56c-.18-.12-.33-.23-.48-.35a18.55,18.55,0,0,1-7.44-14.93,18.72,18.72,0,1,1,30.37,14.63,2.44,2.44,0,0,1-.3.25,18.74,18.74,0,0,1-11.35,3.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "268.11px 347.754px"
    },
    id: "eluquxpi79v1q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.14,366.49a19.16,19.16,0,0,1-5.37-2.68,7.56,7.56,0,0,1,3.88.92s0,0,0,0a2.94,2.94,0,0,1,.6.45A3.1,3.1,0,0,1,262.14,366.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "259.455px 365.148px"
    },
    id: "el7xs1woy7o0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,363.13a3,3,0,0,1-.34.28,19.11,19.11,0,0,1-4.2,2.44,19.5,19.5,0,0,1-11.29,1.23A5.17,5.17,0,0,1,264,367a14.79,14.79,0,0,1-1.82-.48,19.16,19.16,0,0,1-5.37-2.68c-.18-.12-.34-.24-.51-.37h0c1.39-.3,3.14-.62,4.93-.82l.56-.06a107.83,107.83,0,0,1,11.12-.14h.46c1.89.08,3.79.28,5.32.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.315px 364.894px"
    },
    id: "elnnpwuamg7ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,363.41a19.11,19.11,0,0,1-4.2,2.44A5.73,5.73,0,0,1,280,363.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.9px 364.63px"
    },
    id: "el1o9o7ultu7n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.37,362.42s-.81,3.05-7.35,3.28a8,8,0,0,0-1.52,1.38A5.17,5.17,0,0,1,264,367a11.66,11.66,0,0,1-.17-1.3,7.88,7.88,0,0,1-2.54-.48,1.44,1.44,0,0,1-.6-.45h0c-.68-.93,1.14-2.18,1.14-2.18,3.38-.85,3.94-3,3.67-5.27a8.27,8.27,0,0,0-.12-.85c0-.24-.08-.47-.14-.7,0-.06,0-.11,0-.16l4.2-3.61,1.29-1.1,1.8-1.55c0,.06,0,.12,0,.18h0c-.09.44-.19.91-.27,1.42C271.47,354.81,271.11,360.28,273.37,362.42Z",
    style: {
      fill: "rgb(206, 122, 99)",
      transformOrigin: "266.954px 358.215px"
    },
    id: "elgbyxmdslllh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elct7bzedt7e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.16,355.57a11.57,11.57,0,0,1,.3,1.71c1.59-.35,3.68-2.07,3.87-3.7a7.48,7.48,0,0,0,0-1.62Z",
    style: {
      opacity: 0.2,
      transformOrigin: "267.267px 354.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262,336.36c-2.52,1.19-3.8,8.35-.55,9.82S266.71,334.11,262,336.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.146px 341.199px"
    },
    id: "el6bs9yol3c3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.64,343.88c-1,5-1.33,8-4.25,10.32a6.64,6.64,0,0,1-10.83-4.6c-.47-4.64,1.25-12.07,6.48-13.57A6.73,6.73,0,0,1,273.64,343.88Z",
    style: {
      fill: "rgb(206, 122, 99)",
      transformOrigin: "266.14px 345.712px"
    },
    id: "els145l9k3slc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.8,337.84l.25-4.38a5.83,5.83,0,0,0,3.55.42c5.15-1.26,9.13,2,6.75,4.94,2.45,1,1.13,4.39-.49,6.53-2.24,3-4.65,4.39-6.32,3.07-1.5-.72-1.78-5.88-1.3-7.8C272,337.74,268.8,337.84,268.8,337.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "274.751px 341.19px"
    },
    id: "el5b984jaa68v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,349.07a5.48,5.48,0,0,1-3.14,1.94c-1.57.3-1.95-1.15-1.18-2.58s2.36-3,3.78-2.63S275.88,347.83,274.88,349.07Z",
    style: {
      fill: "rgb(206, 122, 99)",
      transformOrigin: "272.855px 348.397px"
    },
    id: "eln4wxcl7w6wa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.76,344.51c-.05.41-.32.72-.59.69s-.44-.38-.38-.79.32-.72.59-.69S265.82,344.1,265.76,344.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.275px 344.46px"
    },
    id: "elkitg5wz4utf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,344c-.05.41-.32.72-.59.69s-.44-.38-.38-.79.32-.73.59-.7S261.16,343.62,261.1,344Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.615px 343.945px"
    },
    id: "eli8ni6tis1ij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.56,344.39a15.41,15.41,0,0,1-2.46,3.31,2.33,2.33,0,0,0,1.92.57Z",
    style: {
      fill: "rgb(186, 77, 60)",
      transformOrigin: "261.33px 346.344px"
    },
    id: "elhk92gr7mg09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.41,343.16a.19.19,0,0,0,.12,0,.25.25,0,0,0,.09-.33,2.35,2.35,0,0,0-1.85-1.2.24.24,0,0,0-.25.24.25.25,0,0,0,.24.25,1.83,1.83,0,0,1,1.43.95A.26.26,0,0,0,267.41,343.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "266.585px 342.4px"
    },
    id: "elxgm00zdq959",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.32,342.24a.29.29,0,0,0,.2-.11,2,2,0,0,1,1.52-1,.25.25,0,0,0,.24-.25.26.26,0,0,0-.25-.24h0a2.5,2.5,0,0,0-1.92,1.18.23.23,0,0,0,.07.33A.24.24,0,0,0,259.32,342.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "260.174px 341.44px"
    },
    id: "el37wmq9zn9b3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,334.43s-4.08-6.71-10.69-4.84a5.26,5.26,0,0,1,1.88.65s-5.89-.1-7.44,4.13l1.08-.73s-1.26,3.51.64,5.64l.25-1.15s2.6,2.81,6.12,1.72l-1.28-.54s6.15-.61,7.58-2.29A14,14,0,0,0,272.91,334.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.785px 334.681px"
    },
    id: "elu9xy19lha3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,349.72a33.29,33.29,0,0,1,6.2-1.08,3.7,3.7,0,0,1-3.62,2.93A2.16,2.16,0,0,1,261.1,349.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.2px 350.127px"
    },
    id: "el0yo5u2ztxsv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.65,350.36a4.34,4.34,0,0,0-2.49,1,2.61,2.61,0,0,0,1.52.25,4.3,4.3,0,0,0,2.48-1A2.43,2.43,0,0,0,264.65,350.36Z",
    style: {
      fill: "rgb(160, 39, 36)",
      transformOrigin: "264.16px 350.982px"
    },
    id: "elfapn513za3m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.31,349.66a1,1,0,0,0,.8.6,24.76,24.76,0,0,0,4-.8,1.34,1.34,0,0,0,1-.8A37.52,37.52,0,0,0,261.31,349.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "264.21px 349.46px"
    },
    id: "ellltf5bqqxdd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.92,366.46a19.5,19.5,0,0,1-2.38-.15,18.37,18.37,0,0,1-3.79-.9,18,18,0,0,1-3.94-1.92,14.76,14.76,0,0,1-1.46-1.05l-.26-.21h0l-.34-.29c-.23-.19-.41-.36-.59-.53a18.71,18.71,0,1,1,26.62-1.07h-.53v.56c-.33.33-.66.64-1,.91a3.06,3.06,0,0,1-.24.22,17.1,17.1,0,0,1-2.58,1.83h-.69v.39a18.53,18.53,0,0,1-8,2.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "357.942px 347.749px"
    },
    id: "el4ucmf61ffqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.17,361.27h0a14.08,14.08,0,0,1-1.32,1.25l-.22.2a18.33,18.33,0,0,1-2.95,2.06h0a19.32,19.32,0,0,1-8.93,2.57,13.28,13.28,0,0,1-3.31-.14,19.5,19.5,0,0,1-4-.94,18.84,18.84,0,0,1-4.13-2,5.3,5.3,0,0,1,.38-2.82,5.6,5.6,0,0,1,.25-.54.36.36,0,0,1,0-.09h0a4.5,4.5,0,0,1,.32-.55,4,4,0,0,1-2.57-3.35,7.09,7.09,0,0,1,1.18-5s-1.92-.37-2.39-3.76a4.41,4.41,0,0,1,1.93-4.66c-1.08-4,2.11-5.23,2.11-5.23.36-3.92,4.47-3.27,4.47-3.27s1.55-3,6.13-.7c0,0,1.6-1.55,5,0a5.7,5.7,0,0,1,3.09,4c6.22,2.38,3.61,7.87,3.61,7.87,3,4.7,0,7.86,0,7.86C373.42,357.88,372.71,360.27,372.17,361.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.531px 350.414px"
    },
    id: "elgz56h8ugw9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.53,366.06l-.09.23a18.84,18.84,0,0,1-4.13-2,15.57,15.57,0,0,1-1.55-1.11s0,0-.05,0a5.28,5.28,0,0,1-.59-.49h0c-.21-.17-.41-.35-.61-.54a2.17,2.17,0,0,1,1.21-1h.22a8.11,8.11,0,0,1,1.3-.15h.42l.29,0a3.54,3.54,0,0,1,2.21.84,4.32,4.32,0,0,1,.44.42,8.17,8.17,0,0,1,1,1.4A3.26,3.26,0,0,1,351.53,366.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "348.153px 363.645px"
    },
    id: "elct420tqfaev",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el38a47nzctvi"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "348.153px 363.645px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.53,366.06l-.09.23a18.84,18.84,0,0,1-4.13-2,15.57,15.57,0,0,1-1.55-1.11s0,0-.05,0a5.28,5.28,0,0,1-.59-.49h0c-.21-.17-.41-.35-.61-.54a2.17,2.17,0,0,1,1.21-1h.22a8.11,8.11,0,0,1,1.3-.15h.42l.29,0a3.54,3.54,0,0,1,2.21.84,4.32,4.32,0,0,1,.44.42,8.17,8.17,0,0,1,1,1.4A3.26,3.26,0,0,1,351.53,366.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "348.153px 363.645px"
    },
    id: "elld437eb152p",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elsgpkb1o6oul"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.76,363.16s0,0-.05,0l0-.14Z",
    style: {
      opacity: 0.2,
      transformOrigin: "345.735px 363.09px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,362.53l-.22.2a18.33,18.33,0,0,1-2.95,2.06h0a19.32,19.32,0,0,1-8.93,2.57,13.28,13.28,0,0,1-3.31-.14,19.5,19.5,0,0,1-4-.94,18.84,18.84,0,0,1-4.13-2,15.57,15.57,0,0,1-1.55-1.11s0,0-.05,0a5.28,5.28,0,0,1-.59-.49h0a.24.24,0,0,1,0-.09.44.44,0,0,0,0-.1l0-.17a3.41,3.41,0,0,1,.39-1.06l.07-.08,0,0,0,0h.22l.34,0,1-.11h0l.39,0,.33,0h.35l.4,0,.35,0h0l.41,0c.17,0,.33,0,.5,0l.36,0,.44,0c.24,0,.49,0,.74,0l.69-.05c.66,0,1.34-.07,2-.08h.14a56.32,56.32,0,0,1,7.43.48c.54.05,1.1.13,1.66.19l.74.11.59.08.86.14.66.11.37.08c.52.09,1,.19,1.49.29l.61.14h0l.12,0,.5.11h0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "357.983px 364.173px"
    },
    id: "elj2oyxh8ywp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp0bofd05hw"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "357.985px 364.193px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.85,362.53l-.22.2a18.33,18.33,0,0,1-2.95,2.06h0a19.32,19.32,0,0,1-8.93,2.57,13.28,13.28,0,0,1-3.31-.14,19.5,19.5,0,0,1-4-.94,18.84,18.84,0,0,1-4.13-2,15.57,15.57,0,0,1-1.55-1.11s0,0-.05,0a5.28,5.28,0,0,1-.59-.49.3.3,0,0,0,0-.1.44.44,0,0,0,0-.1l0-.17a3.41,3.41,0,0,1,.39-1.06l.07-.08,0,0,0,0h.22l.34,0c.25,0,.58-.07,1-.11h0l.39,0,.34,0h.34l.4,0,.35,0h0l.41,0c.17,0,.33,0,.5,0l.36,0,.33,0h.12l.74,0,.68,0c.66,0,1.34-.07,2-.08h.14a56.32,56.32,0,0,1,7.43.48c.54.05,1.1.13,1.66.19l.74.11.59.08.86.14.66.11.37.08c.52.09,1,.19,1.49.29l.61.14h0l.12,0,.5.11h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "357.985px 364.193px"
    },
    id: "elo28sjboxrhl",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.09,351c-.79,2.92-1.77,8.32.16,10.45,0,0-1,3-6.55,2.56-6.07-.45-2.68-3.23-2.68-3.23,3.37-.55,3.46-3,3.06-5.36Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "357.163px 357.527px"
    },
    id: "el6q678c2zxfh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcjn4yab9dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.64,352.84l-3.56,2.62a9.42,9.42,0,0,1,.16,1.66c1.28-.09,3.12-1.36,3.35-2.67A4.27,4.27,0,0,0,359.64,352.84Z",
    style: {
      opacity: 0.2,
      transformOrigin: "357.887px 354.98px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M363,343.83c-.14,5-.1,7.09-2.53,9.72-3.65,4-9.73,2.69-11.07-2.23-1.22-4.43-.77-11.82,4-14A6.79,6.79,0,0,1,363,343.83Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "355.916px 346.309px"
    },
    id: "elm9kuo83oqno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.1,338.93c-1.15,2.55,16.1,7.66,13.54,2.73S353.09,332.28,350.1,338.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.972px 339.647px"
    },
    id: "elpwvdaxvdj3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,342.66c.09,2.39,3.71,4.51,3.71,4.51s3.32-3.69.54-4.73S359.11,342.66,359.11,342.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.79px 344.599px"
    },
    id: "elk8tj9q8dkuk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.82,345.47c0,.41-.2.74-.46.75s-.49-.31-.5-.72.19-.74.45-.74S354.8,345.07,354.82,345.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.34px 345.49px"
    },
    id: "elfsv0rznhjlm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,345.62c0,.4-.19.74-.45.75s-.49-.32-.5-.72.19-.74.45-.75S350.23,345.21,350.24,345.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.765px 345.635px"
    },
    id: "elyqu4e1xgxwd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.86,344.92l-1-.25S349.4,345.41,349.86,344.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.36px 344.879px"
    },
    id: "elmtggdje2zp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,346.24a10.87,10.87,0,0,1-1.36,2.63,1.74,1.74,0,0,0,1.45.22Z",
    style: {
      fill: "rgb(213, 135, 69)",
      transformOrigin: "351.365px 347.7px"
    },
    id: "elblerquwgdk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.5,348.35a3.61,3.61,0,0,1-1.83,2.09c-1.14.56-1.95-.42-1.82-1.62s.86-2.68,2.1-2.73A1.63,1.63,0,0,1,364.5,348.35Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "362.732px 348.346px"
    },
    id: "el1ezcben6q41",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,344.48a.23.23,0,0,1-.25-.12,2.87,2.87,0,0,0-1.95-1.14.24.24,0,0,1-.21-.26.25.25,0,0,1,.27-.21,3.31,3.31,0,0,1,2.31,1.38.25.25,0,0,1-.1.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.513px 343.617px"
    },
    id: "ellyz9jtrlbw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.8,343.55a.22.22,0,0,1-.22-.08.23.23,0,0,1,0-.33,2.32,2.32,0,0,1,2.09-.57.24.24,0,0,1,.17.29.24.24,0,0,1-.29.16h0a1.89,1.89,0,0,0-1.66.48A.22.22,0,0,1,348.8,343.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.679px 343.035px"
    },
    id: "eloh7bq2fmjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,344.77l-1-.25S354,345.27,354.43,344.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.93px 344.731px"
    },
    id: "elo3hmjy4fkv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.07,350.59a14.31,14.31,0,0,1,1.26,1.69,3.49,3.49,0,0,0,.34-.15c1.55-.68,2-1.51,2.11-2.22a2.25,2.25,0,0,0-.44-1.53,8,8,0,0,1-2.75,2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.929px 350.33px"
    },
    id: "el5eln2xodlqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.59,350.35l.39.49c1.45-.65,2.39-1.3,2.65-1.94a2.28,2.28,0,0,0-.29-.52A8,8,0,0,1,353.59,350.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "355.11px 349.61px"
    },
    id: "elhjr58pd75t7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.67,352.13c1.55-.68,2-1.51,2.11-2.22a5.7,5.7,0,0,0-1.56,1.1A2.06,2.06,0,0,0,354.67,352.13Z",
    style: {
      fill: "rgb(222, 87, 83)",
      transformOrigin: "355.725px 351.02px"
    },
    id: "eljmgaekyz70c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.44,362.17a21.26,21.26,0,0,1-5.46,3.76l-.61.27a15.36,15.36,0,0,1-4.63,1.17,13.28,13.28,0,0,1-3.31-.14l-.3-.05a14.9,14.9,0,0,1-3.6-1.12,8.28,8.28,0,0,1-2.11-1.37c-.16-.15-.31-.3-.45-.46a5,5,0,0,1-1.28-2.78,3.87,3.87,0,0,1,0-.56v0l.34,0h.34l.4,0,.35,0h0l.41,0c.17,0,.33,0,.5,0l.36,0,.33,0h.12l.74,0,.68,0c.66,0,1.34-.07,2-.08h.14a56.32,56.32,0,0,1,7.43.48c.54.05,1.1.13,1.66.19l.74.11.59.08.86.14.66.11.37.08c.52.09,1,.19,1.49.29l.61.14h0l.12,0Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "358.56px 364.113px"
    },
    id: "elvb86bz2d458",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,365.93l-.6.27a25.39,25.39,0,0,1,.86-5l.59.08A26.57,26.57,0,0,0,364,365.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.125px 363.7px"
    },
    id: "elc3ad9uhi7ib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.58,360.53a21.05,21.05,0,0,0-2.16,4.16c-.16-.15-.31-.3-.45-.46a22.06,22.06,0,0,1,1.87-3.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "350.275px 362.61px"
    },
    id: "elh205hvkcigc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.63,362.73a18.33,18.33,0,0,1-2.95,2.06A5.15,5.15,0,0,1,370.63,362.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "369.155px 363.76px"
    },
    id: "eldqab67s4b1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2d6apiwub5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "369.155px 363.76px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370.63,362.73a18.33,18.33,0,0,1-2.95,2.06A5.15,5.15,0,0,1,370.63,362.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "369.155px 363.76px"
    },
    id: "elceddb0m6328",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eli5i6lrotkbe"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "364.125px 363.7px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364,365.93l-.6.27a25.39,25.39,0,0,1,.86-5l.59.08A26.57,26.57,0,0,0,364,365.93Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "364.125px 363.7px"
    },
    id: "el2tfwu9wkjgy",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elaw7igz9fyga"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "350.275px 362.61px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.58,360.53a21.05,21.05,0,0,0-2.16,4.16c-.16-.15-.31-.3-.45-.46a22.06,22.06,0,0,1,1.87-3.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "350.275px 362.61px"
    },
    id: "elhpnyq0g1aqj",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elo2qfuo7t6mf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.58,347.75a19.51,19.51,0,0,1-5.41,13.52h0a14.08,14.08,0,0,1-1.32,1.25l-.22.2a18.33,18.33,0,0,1-2.95,2.06h0a19.32,19.32,0,0,1-8.93,2.57l-.82,0a20.55,20.55,0,0,1-2.49-.16,19.5,19.5,0,0,1-4-.94,18.84,18.84,0,0,1-4.13-2,15.57,15.57,0,0,1-1.55-1.11s0,0-.05,0a5.28,5.28,0,0,1-.59-.49h0c-.21-.17-.41-.35-.61-.54a19.64,19.64,0,1,1,33.08-14.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "357.95px 347.749px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh4jr5vy5eol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.66,347.77A19.56,19.56,0,0,1,325.4,363h0c-.41.35-.83.66-1.26,1a18.37,18.37,0,0,1-3.16,1.76,18.77,18.77,0,0,1-4.33,1.34h0l-.37.07a20.58,20.58,0,0,1-3.26.27,19,19,0,0,1-4.15-.45,18.41,18.41,0,0,1-2.47-.7,18,18,0,0,1-2.76-1.24,6.22,6.22,0,0,1-.56-.32l-.36-.21-.28-.19a13.49,13.49,0,0,1-1.52-1.08,10.52,10.52,0,0,1-.9-.75h0l-.22-.2a19.64,19.64,0,1,1,32.88-14.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "313.04px 347.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313,366.48a18.39,18.39,0,0,1-3.95-.42,17.07,17.07,0,0,1-2.35-.67,18.53,18.53,0,0,1-2.64-1.17l-.53-.31a1.54,1.54,0,0,1-.23-.14l-.11-.06-.24-.16a17,17,0,0,1-1.47-1,9.82,9.82,0,0,1-.84-.71l-.27-.25h0a18.71,18.71,0,1,1,24.71.53l-.28.22c-.38.32-.77.61-1.19.9a18.25,18.25,0,0,1-3,1.68,17.92,17.92,0,0,1-4.13,1.27l-.73.13A17.91,17.91,0,0,1,313,366.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313.026px 347.792px"
    },
    id: "elopub7dtxhye",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.77,348a23.19,23.19,0,0,1,0,6.22s12.51,1.73,15.55-.58,4.38-16.08-2.39-17.4S300.17,339.54,301.77,348Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.689px 345.43px"
    },
    id: "elx2t8ahqezhe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.13,364a18.37,18.37,0,0,1-3.16,1.76,18.77,18.77,0,0,1-4.33,1.34h0l-.37.07a20.58,20.58,0,0,1-3.26.27,19,19,0,0,1-4.15-.45,18.41,18.41,0,0,1-2.47-.7,18,18,0,0,1-2.76-1.24,6.22,6.22,0,0,1-.56-.32l-.36-.21-.28-.19a13.49,13.49,0,0,1-1.52-1.08,10.52,10.52,0,0,1-.9-.75,19,19,0,0,1,2.13-.49h0c.63-.12,1.21-.18,1.7-.23l.73,0c.22,0,.41,0,.55,0h.29c0,.11,0,.22,0,.32h0a1.63,1.63,0,0,0,1.05,1.94,8,8,0,0,0,4.39-.32c.38-.11.76-.22,1.14-.35a43.73,43.73,0,0,0,4.57-1.81l.72-.34h.37a10.08,10.08,0,0,1,3.12.48h.08A7,7,0,0,1,324.13,364Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "312.07px 364.33px"
    },
    id: "elvz2laa37wgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elclh0484o509"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324.13,364a18.37,18.37,0,0,1-3.16,1.76,18.77,18.77,0,0,1-4.33,1.34h0l-.37.07a20.58,20.58,0,0,1-3.26.27,19,19,0,0,1-4.15-.45,18.41,18.41,0,0,1-2.47-.7,18,18,0,0,1-2.76-1.24,6.22,6.22,0,0,1-.56-.32l-.36-.21-.28-.19a13.49,13.49,0,0,1-1.52-1.08,10.52,10.52,0,0,1-.9-.75,19,19,0,0,1,2.13-.49h0c.63-.12,1.21-.18,1.7-.23l.73,0c.22,0,.41,0,.55,0h.29c0,.11,0,.22,0,.32h0a1.63,1.63,0,0,0,1.05,1.94,8,8,0,0,0,4.39-.32c.38-.11.76-.22,1.14-.35a43.73,43.73,0,0,0,4.57-1.81l.72-.34h.37a10.08,10.08,0,0,1,3.12.48h.08A7,7,0,0,1,324.13,364Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "312.07px 364.33px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M311.54,363.65h-.71a24.77,24.77,0,0,1-2,3.33,18.41,18.41,0,0,1-2.47-.7,3.79,3.79,0,0,1,.08-1.94c-4-.34-2.35-1.62-1.08-2.31h0c.51-.27.95-.45.95-.45a5,5,0,0,0,2.56-1.32,4.17,4.17,0,0,0,1-3c0-.15,0-.3,0-.45a8.77,8.77,0,0,0-.16-1.24.71.71,0,0,0,0-.14h0l.67-.54,3.29-2.64,2.62-2.1.11-.09a1,1,0,0,0,0,.18c-.2.72-.41,1.58-.57,2.49-.06.27-.11.55-.15.83h0a8.46,8.46,0,0,0-.12.86h0c0,.19-.06.39-.08.57a14.19,14.19,0,0,0,.15,4.74,4.26,4.26,0,0,0,.9,1.79l.07.08S319.38,363.77,311.54,363.65Z",
    style: {
      fill: "rgb(238, 193, 187)",
      transformOrigin: "310.498px 358.52px"
    },
    id: "elhm56hy44qiu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6ndyp6gkb5m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.72,352.19l-4,3.18a10.41,10.41,0,0,1,.18,1.83c1.42-.21,3.47-1.75,3.73-3.22A5.07,5.07,0,0,0,313.72,352.19Z",
    style: {
      opacity: 0.2,
      transformOrigin: "311.741px 354.695px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.27,343.37c-1,5.33-1.31,7.6-4.35,10.16-4.58,3.85-10.87,1.81-11.48-3.62-.54-4.9,1.19-12.8,6.69-14.56A7,7,0,0,1,319.27,343.37Z",
    style: {
      fill: "rgb(238, 193, 187)",
      transformOrigin: "311.379px 345.241px"
    },
    id: "elgvnu9pw2lk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.69,339.51c2.94,3.8-3.11,8.17,2.94,7.92s3.59-8.8,0-10.74S314.69,339.51,314.69,339.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "317.973px 341.833px"
    },
    id: "elx24t769mnfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.82,344.25c-.06.46-.35.8-.64.78s-.47-.4-.4-.85.35-.8.64-.78S310.89,343.8,310.82,344.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.3px 344.215px"
    },
    id: "el6eexybc7ebf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.37,343.93c-.06.45-.35.8-.64.78s-.47-.4-.4-.85.35-.8.64-.78S305.44,343.48,305.37,343.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.85px 343.895px"
    },
    id: "el0l0e9is80z9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,343.11l-1-.39S304.5,343.61,305.09,343.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.59px 342.991px"
    },
    id: "eldyqvc51euh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.78,344.78a13.48,13.48,0,0,1-2,2.77,1.83,1.83,0,0,0,1.54.42Z",
    style: {
      fill: "rgb(212, 130, 125)",
      transformOrigin: "305.78px 346.391px"
    },
    id: "elsfuh4csjoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.63,349.82a3.74,3.74,0,0,1-.75,0,.12.12,0,0,1-.11-.14.14.14,0,0,1,.15-.12,3.78,3.78,0,0,0,3.05-1.19.13.13,0,0,1,.19,0,.13.13,0,0,1,0,.18A4,4,0,0,1,308.63,349.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "309.482px 349.084px"
    },
    id: "elgyv9hk10op8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.34,341.83a.25.25,0,0,1-.18-.08,1.91,1.91,0,0,0-1.73-.66.25.25,0,0,1-.29-.21.29.29,0,0,1,.23-.32,2.45,2.45,0,0,1,2.19.82.27.27,0,0,1,0,.37A.29.29,0,0,1,312.34,341.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.386px 341.183px"
    },
    id: "el55q16zmdc6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,341.34a.2.2,0,0,1-.18-.06.26.26,0,0,1,0-.37,2.81,2.81,0,0,1,2.26-1,.26.26,0,0,1,.21.3.3.3,0,0,1-.31.23,2.23,2.23,0,0,0-1.78.81A.26.26,0,0,1,304.15,341.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.168px 340.625px"
    },
    id: "elqzjs4awe98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.54,343.43l-1-.39S310,343.93,310.54,343.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.04px 343.311px"
    },
    id: "elbn2fx5cb3z8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.62,336.55s1.05,6.29,5.23,7.34.78-6.46.78-6.46-.88-3.41-6.52-3.41a11.24,11.24,0,0,0-10.34,14,9.07,9.07,0,0,1,.94-4.91C304,340.91,305.24,342.78,312.62,336.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.678px 341.02px"
    },
    id: "elo2n1uielmq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.42,335c6,2.39,8.13,6.3,7.63,10.64s-5.86,8.93-6.73,9.09l-2.68.38s4.12-5.73,3.33-7.67-1.59-2.14-1.59-2.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "319.38px 345.055px"
    },
    id: "elfbfbr1hawdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.79,348.51a3.75,3.75,0,0,1-2.27,2c-1.24.33-1.78-1.1-1.36-2.52s1.46-3,2.68-2.68S320.42,347.26,319.79,348.51Z",
    style: {
      fill: "rgb(238, 193, 187)",
      transformOrigin: "318.057px 347.913px"
    },
    id: "elrx8hkz6zuw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,362.13c.49.14,1.57.55,2.42.88-.41.35-.83.66-1.26,1a18.37,18.37,0,0,1-3.16,1.76,18.77,18.77,0,0,1-4.33,1.34c.09-.32.19-.62.29-.92A1.06,1.06,0,0,1,317,366l.12-.35,0-.08c.08-.24.17-.47.26-.7.15-.4.31-.78.48-1.13a3.4,3.4,0,0,1,.16-.34c0-.11.12-.22.17-.33s0,0,0,0a.21.21,0,0,0,0-.06c.07-.13.15-.25.21-.37l.28-.43a5.85,5.85,0,0,1,.66-.77l.64.12.46.09a1.18,1.18,0,0,1,.25,0h.08a.71.71,0,0,1,.2,0l1,.2.22.05.57.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.045px 364.275px"
    },
    id: "elnzjvogncry",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc54wf468auc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323,362.13c.49.14,1.57.55,2.42.88-.41.35-.83.66-1.26,1a18.37,18.37,0,0,1-3.16,1.76,18.77,18.77,0,0,1-4.33,1.34c.09-.32.19-.62.29-.92A1.06,1.06,0,0,1,317,366l.12-.35,0-.08c.08-.24.17-.47.26-.7.15-.4.31-.78.48-1.13a3.4,3.4,0,0,1,.16-.34c0-.11.12-.22.17-.33s0,0,0,0a.21.21,0,0,0,0-.06c.07-.13.15-.25.21-.37l.28-.43a5.85,5.85,0,0,1,.66-.77l.64.12.46.09a1.18,1.18,0,0,1,.25,0h.08a.71.71,0,0,1,.2,0l1,.2.22.05.57.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "321.045px 364.275px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M321,365.73a18.77,18.77,0,0,1-4.33,1.34h0l-.37.07c.11-.38.23-.74.35-1.09a14.36,14.36,0,0,1,1.58-3.31,6.27,6.27,0,0,1,1.2-1.37A27.66,27.66,0,0,1,321,365.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.65px 364.255px"
    },
    id: "elx9gk69ijvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.89,361.72l0,0a16.46,16.46,0,0,0-.8,1.8h0c-.11.27-.22.59-.35.93l-.28-.19a13.49,13.49,0,0,1-1.52-1.08,10.52,10.52,0,0,1-.9-.75h0l-.22-.2a18.85,18.85,0,0,1,3-.52C303.16,361.73,303.52,361.72,303.89,361.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.855px 363.08px"
    },
    id: "el90a0lp3v5f9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els7he8lidsd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.89,361.72l0,0a16.46,16.46,0,0,0-.8,1.8h0c-.11.27-.22.59-.35.93l-.28-.19a13.49,13.49,0,0,1-1.52-1.08,10.52,10.52,0,0,1-.9-.75h0l-.22-.2a18.85,18.85,0,0,1,3-.52C303.16,361.73,303.52,361.72,303.89,361.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "301.855px 363.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M304.59,361.72a2.38,2.38,0,0,0-.82,1.11,12.33,12.33,0,0,0-.7,1.88l-.36-.21-.28-.19a13.49,13.49,0,0,1-1.52-1.08,3.93,3.93,0,0,1,1.23-1.24h0a4.26,4.26,0,0,1,.65-.23A2.58,2.58,0,0,1,304.59,361.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.75px 363.144px"
    },
    id: "el53oou0lu494",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.44,364a2.31,2.31,0,0,0,0,.37l-2.84.7a6.22,6.22,0,0,1-.56-.32l-.36-.21-.28-.19a9.28,9.28,0,0,1,.63-.74h0c.21-.24.45-.48.71-.73a10.44,10.44,0,0,1,1.37-1.13,7.71,7.71,0,0,1,3.76-1.46h.1S306.46,362,306.44,364Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "305.685px 362.68px"
    },
    id: "elz400n49ckbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.76,366.42l-6.87-2.23a36.45,36.45,0,0,0,4.77-4.52l2.27,1.7h0C318,361.5,318.66,363.17,317.76,366.42Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "314.559px 363.045px"
    },
    id: "elpd9g0v1mfl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8hxvhou62d4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.44,364a2.31,2.31,0,0,0,0,.37l-2.84.7a6.22,6.22,0,0,1-.56-.32l-.36-.21-.28-.19a9.28,9.28,0,0,1,.63-.74h0c.21-.24.45-.48.71-.73a10.44,10.44,0,0,1,1.37-1.13,7.71,7.71,0,0,1,3.76-1.46h.1S306.46,362,306.44,364Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "305.685px 362.68px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqao80nue8cf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.76,366.42l-6.87-2.23a36.45,36.45,0,0,0,4.77-4.52l2.27,1.7h0C318,361.5,318.66,363.17,317.76,366.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "314.559px 363.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.52,364.64h0a.57.57,0,0,1-.44-.2l-2.45-2.89a.57.57,0,0,1,.87-.75l2,2.38,3.33-3.93a.58.58,0,0,1,.82-.06.57.57,0,0,1,.06.81L282,364.44A.57.57,0,0,1,281.52,364.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.172px 361.845px"
    },
    id: "el19vqdmcjab5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,364.64h0a.57.57,0,0,1-.44-.2l-2.45-2.89a.57.57,0,0,1,.87-.75l2,2.38,3.33-3.93a.58.58,0,0,1,.82-.06.57.57,0,0,1,.06.81l-3.77,4.44A.57.57,0,0,1,326.43,364.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "327.081px 361.844px"
    },
    id: "elbrfubv5xdnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,383.75a.54.54,0,0,1-.22-.05l-5.89-3.13a.47.47,0,0,1-.2-.63.47.47,0,0,1,.63-.19l5.68,3,5.68-3a.47.47,0,0,1,.63.19.47.47,0,0,1-.2.63l-5.89,3.13A.59.59,0,0,1,313,383.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313px 381.723px"
    },
    id: "elzud2w0ay6xi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313,380a.43.43,0,0,1-.22-.06l-5.89-3.12a.47.47,0,1,1,.43-.83l5.68,3,5.68-3a.47.47,0,1,1,.43.83L313.24,380A.46.46,0,0,1,313,380Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "313px 377.964px"
    },
    id: "elirqn6h74y0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elut6vglu00g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 254.25,
    y: 139.84,
    width: 1.86,
    height: 2.48,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "255.18px 141.08px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7s4urh6m1on"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251.21,
    y: 139.01,
    width: 1.86,
    height: 3.31,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "252.14px 140.665px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elvelc24ut2wm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.18,
    y: 138.18,
    width: 1.86,
    height: 4.14,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "249.11px 140.25px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2mdwyofwrva"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 245.14,
    y: 137.35,
    width: 1.86,
    height: 4.97,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "246.07px 139.835px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgzbi4hm46t"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 370.24,
    y: 138.93,
    width: 1.1,
    height: 2.48,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "370.79px 140.17px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4iwt6ulrlz3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 372.1,
    y: 138.02,
    width: 8.79,
    height: 4.29,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "376.495px 140.165px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb096mv1rxo4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.27,131.4,237.63,274V134.73a3.21,3.21,0,0,1,3.08-3.33H276.5a2.53,2.53,0,0,1,2.31,1.61l1.48,3.65a2.51,2.51,0,0,0,2.3,1.6h60.94a2.5,2.5,0,0,0,2.3-1.57l1.48-3.67a2.53,2.53,0,0,1,2.31-1.62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "308.949px 202.7px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elp1lz2xyb2b"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.41 157.84 388.41 169.55 237.63 320.32 237.63 308.62 388.41 157.84",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "313.02px 239.08px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,367.42a5.57,5.57,0,1,1,5.57-5.57A5.58,5.58,0,0,1,282.18,367.42Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "282.18px 361.85px"
    },
    id: "elqk8yfcuox6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.18,367.88a6,6,0,1,1,6-6A6,6,0,0,1,282.18,367.88Zm0-11.13a5.1,5.1,0,1,0,5.1,5.1A5.1,5.1,0,0,0,282.18,356.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "282.18px 361.88px"
    },
    id: "el4n26fl8lope",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.09,367.42a5.57,5.57,0,1,1,5.57-5.57A5.58,5.58,0,0,1,327.09,367.42Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "327.09px 361.85px"
    },
    id: "eldkpqkdbuut7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.09,367.88a6,6,0,1,1,6-6A6,6,0,0,1,327.09,367.88Zm0-11.13a5.1,5.1,0,1,0,5.1,5.1A5.1,5.1,0,0,0,327.09,356.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "327.09px 361.88px"
    },
    id: "eldbl71w5ukqq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-19",
    className: "animable",
    style: {
      transformOrigin: "167.595px 148.261px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.31,125.09h36.57a4.85,4.85,0,0,1,4.85,4.85V159a4.85,4.85,0,0,1-4.85,4.85h-3.2l6.55,12.94-12.09-12.94H149.3a4.85,4.85,0,0,1-4.84-4.85V129.94A4.85,4.85,0,0,1,149.31,125.09Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "167.595px 150.94px"
    },
    id: "elma0lnm131vg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqn6myqwbjxq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.31,125.09h36.57a4.85,4.85,0,0,1,4.85,4.85V159a4.85,4.85,0,0,1-4.85,4.85h-3.2l6.55,12.94-12.09-12.94H149.3a4.85,4.85,0,0,1-4.84-4.85V129.94A4.85,4.85,0,0,1,149.31,125.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "167.595px 150.94px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 149.79,
    y: 122.48,
    width: 35.6,
    height: 35.19,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "167.59px 140.075px"
    },
    id: "el6k8xjhgwgnh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.79,
    y: 122.48,
    width: 35.6,
    height: 8.26,
    style: {
      fill: "rgb(64, 123, 255)",
      isolation: "isolate",
      transformOrigin: "167.59px 126.61px"
    },
    id: "elgru6mjti7tf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.56,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.39,1.39,0,0,1,155.56,127.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.555px 123.746px"
    },
    id: "elwpxoylaiqv8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,127.76a1.39,1.39,0,0,1-1.39-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.39,1.39,0,0,1,161.57,127.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.575px 123.746px"
    },
    id: "el2ich68jqamz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,127.76a1.39,1.39,0,0,1-1.39-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.4,1.4,0,0,1,167.59,127.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.595px 123.746px"
    },
    id: "elqmgr9p7xdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,1,1,2.8,0v5.12A1.4,1.4,0,0,1,173.61,127.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "173.61px 123.805px"
    },
    id: "elz8l6srsv9jc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,0,1,2.8,0v5.12A1.4,1.4,0,0,1,179.63,127.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "179.63px 123.805px"
    },
    id: "elr30uiwvq3x8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgelfy9lvmmd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "167.593px 123.746px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.56,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.39,1.39,0,0,1,155.56,127.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "155.555px 123.746px"
    },
    id: "el61zo61jgczw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.57,127.76a1.39,1.39,0,0,1-1.39-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.39,1.39,0,0,1,161.57,127.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "161.575px 123.746px"
    },
    id: "el3ntqy5kwroq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.59,127.76a1.39,1.39,0,0,1-1.39-1.39v-5.12a1.4,1.4,0,1,1,2.79,0v5.12A1.4,1.4,0,0,1,167.59,127.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "167.595px 123.746px"
    },
    id: "elb4lhgn3ykx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.61,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,1,1,2.8,0v5.12A1.4,1.4,0,0,1,173.61,127.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "173.61px 123.805px"
    },
    id: "ely1d2ofnbb3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,127.76a1.4,1.4,0,0,1-1.4-1.39v-5.12a1.4,1.4,0,0,1,2.8,0v5.12A1.4,1.4,0,0,1,179.63,127.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "179.63px 123.805px"
    },
    id: "elqhzx34bjc88",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M167,148v2.09H157.2v-1.65l5.29-5c1.29-1.23,1.52-2,1.52-2.75,0-1.22-.84-1.92-2.47-1.92a3.75,3.75,0,0,0-3.12,1.39l-1.73-1.33a6.14,6.14,0,0,1,5.05-2.21c2.89,0,4.75,1.47,4.75,3.82,0,1.29-.36,2.47-2.2,4.2L160.74,148Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.845px 143.351px"
    },
    id: "el7qwps7qdwvx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,148v2.09h-9.8v-1.65l5.28-5c1.29-1.23,1.52-2,1.52-2.75,0-1.22-.84-1.92-2.47-1.92a3.77,3.77,0,0,0-3.12,1.39l-1.73-1.33a6.15,6.15,0,0,1,5.06-2.21c2.89,0,4.75,1.47,4.75,3.82,0,1.29-.36,2.47-2.21,4.2L171.79,148Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.9px 143.351px"
    },
    id: "elfm1s547a1eu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-19",
    className: "animable",
    style: {
      transformOrigin: "210.209px 284.754px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.38,207.66c-.7,1.37-1.33,2.53-2,3.76s-1.39,2.4-2.11,3.58q-2.19,3.54-4.68,6.91a70.87,70.87,0,0,1-5.42,6.56,49.06,49.06,0,0,1-6.58,5.95l-.12.08a4.88,4.88,0,0,1-4.14.79,10.62,10.62,0,0,1-5.24-3.38,16.82,16.82,0,0,1-2.53-4,34.27,34.27,0,0,1-2.29-7.56,59.18,59.18,0,0,1-.89-7.26c-.07-1.2-.11-2.39-.12-3.58v-2.7c0-.31,0-.6.74-1a6.85,6.85,0,0,1,5.06-.47l1.25.37c.71.21.79.49.8.75l.09.8.2,1.62c.15,1.07.32,2.14.52,3.21a62.94,62.94,0,0,0,1.31,6.2,24.75,24.75,0,0,0,2,5.39,6.43,6.43,0,0,0,1.17,1.66c.36.35.5.32.4.26l-4.25.88a52,52,0,0,0,9.34-10.78c1.4-2,2.72-4.18,4-6.36.64-1.08,1.25-2.18,1.84-3.28s1.19-2.26,1.66-3.26l0-.06a5.59,5.59,0,0,1,10.1,4.8A.67.67,0,0,0,202.38,207.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.645px 217.502px"
    },
    id: "elcutepr2o9bu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.44,403l6.78-4.74a.58.58,0,0,1,.75,0l4.4,4.19a1.05,1.05,0,0,1-.05,1.48,1.77,1.77,0,0,1-.17.12c-2.37,1.6-3.66,2.33-6.61,4.39-1.81,1.26-9.52,5.86-12.43,6.19s-3.36-2.42-2.19-2.91c5.9-2.5,8.1-5.46,8.77-7.74A1.9,1.9,0,0,1,199.44,403Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.486px 406.39px"
    },
    id: "el1nvul24avec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfokwpoa23w5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.44,403l6.78-4.74a.58.58,0,0,1,.75,0l4.4,4.19a1.05,1.05,0,0,1-.05,1.48,1.77,1.77,0,0,1-.17.12c-2.37,1.6-3.66,2.33-6.61,4.39-1.81,1.26-9.52,5.86-12.43,6.19s-3.36-2.42-2.19-2.91c5.9-2.5,8.1-5.46,8.77-7.74A1.9,1.9,0,0,1,199.44,403Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "200.486px 406.39px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.12,248.53s-25.51,56.76-26.89,77c-1.51,22.18,26.08,79.28,26.08,79.28l12.56-3.32s-19.49-57.69-18.18-74.69c4.19-24.31,33.37-74.23,33.37-74.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.115px 326.67px"
    },
    id: "elh4kpw09i19k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxugh18mes88"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201,372.91c4.49,15.53,8.91,28.58,8.91,28.58l-12.57,3.31s-.89-1.84-2.34-5c-6.64-14.4-25-56.08-23.74-74.28,1.37-20.23,26.88-77,26.88-77l27,4s-29.19,49.91-33.38,74.22C191,335.71,196,355.81,201,372.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "198.169px 326.66px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1ees6qhk6ie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.63,265.41c-6.64,3-11.08,18.79-10.79,27.12,4.62-9.93,9.69-19.65,13.71-27.09A2.9,2.9,0,0,0,214.63,265.41Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "210.688px 278.78px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaplv20hrmh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.88,401.49l-12.57,3.31s-.89-1.84-2.34-5c3.48-9.3,5.25-20.81,6-26.89C205.46,388.44,209.88,401.49,209.88,401.49Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "202.425px 388.855px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.77,244.85,235,246.14s.24,12.22-2.58,21.31l-37-12.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.213px 256.15px"
    },
    id: "elsvtfotbhong",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljr53pfi98n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.77,244.85,235,246.14s.24,12.22-2.58,21.31l-37-12.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "215.213px 256.15px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.06,407.88l8.48.28a.63.63,0,0,1,.58.5l1.17,6.25a1,1,0,0,1-.83,1.2.91.91,0,0,1-.23,0c-2.74-.13-4.73-.36-8.18-.48-2.12-.07-8.52-.05-11.45-.15s-3.22-3-2-3.23c5.41-1,9.51-2.49,11.29-4A1.66,1.66,0,0,1,205.06,407.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.617px 411.996px"
    },
    id: "elymcjysikjh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,247.71s-6.43,59.52-6.72,80c-.32,22.43-1.59,80.6-1.59,80.6l12,1.82s6.67-55.1,8.93-76.83c2.56-24.77,9.68-75.13,9.68-75.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.435px 328.92px"
    },
    id: "ellp2hvwlcrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrie2tivsfac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.44,247.71s-6.43,59.52-6.72,80c-.32,22.43-1.59,80.6-1.59,80.6l12,1.82s6.67-55.1,8.93-76.83c2.56-24.77,9.68-75.13,9.68-75.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "218.435px 328.92px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "203.8 250.2 221.3 251.31 221.52 247.04 204.01 246.15 203.8 250.2",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.66px 248.73px"
    },
    id: "elrms3f6s8sii",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.85 247.11 222.63 251.4 234.6 252.16 234.82 247.72 222.85 247.11",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "228.725px 249.635px"
    },
    id: "ellzbmmcmfe4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.68 246.08 197.58 245.81 196.9 249.77 202.47 250.12 202.68 246.08",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "199.79px 247.965px"
    },
    id: "eldwy1aijjcbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8qb2drsrp23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.57,
    y: 246.24,
    width: 6.9,
    height: 4.97,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "211.02px 248.725px",
      transform: "rotate(2.93deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,194.49c-3.17.62-12.46,22.65-12.46,22.65l8.77,11.11,3.84-5.37Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "188.105px 211.37px"
    },
    id: "elnmswu1e1rx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el05nr6vriha7v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.26,194.49l.08,14,.07,14.36-3.84,5.37-2.18-2.77-6.59-8.34S191.08,195.1,194.26,194.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "188.105px 211.355px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8kq6zqzmrto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.34,208.52l.07,14.36-3.84,5.37-2.18-2.77C187.8,217.25,192.07,211.14,194.34,208.52Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "191.372px 218.385px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.69,203.14a.59.59,0,0,1-.56.72l-6.79.46a.8.8,0,0,1-.81-.63l-2.42-13.29a.68.68,0,0,1,.56-.82l6.79-.46a.89.89,0,0,1,.82.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "174.399px 196.72px"
    },
    id: "elkvq2y6lt619",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0wrjfhkxxdj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.52,189.81,179,203.23a.52.52,0,0,1-.49.68l-5.75.38c-.39,0-1.11-.14-1.18-.51l-2.45-13.47c-.07-.38.57-.73,1-.75l5.75-.39A.7.7,0,0,1,176.52,189.81Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "174.075px 196.73px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,194.49s24.06-3.67,42.48-2c0,0-4.61,35.58-2.2,54.17l-36.16-1.23S190.16,214.42,194.26,194.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.927px 219.357px"
    },
    id: "ele4qe0smhr5m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.43,192.29c-3.11,3.54-11.75,3.34-11.75,3.34s-5.47-.85-4.54-2.63c3.07-.87,4.42-2.5,4.83-4.44a9.2,9.2,0,0,0-.09-3.61,17.54,17.54,0,0,0-.49-2l9.63-9C219.23,179.31,218.61,189,222.43,192.29Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "214.232px 184.791px"
    },
    id: "elss4zhmfg2ho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elh7co370l4zq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.15,179.24c.3,6.35-4.68,8.68-7.18,9.32a9.2,9.2,0,0,0-.09-3.61Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "214.521px 183.9px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "222.21 190.35 217.6 193.33 226.52 252.16 241.01 257.6 236.74 192.5 222.21 190.35",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "229.305px 223.975px"
    },
    id: "eli5kjdwktu6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8sfjowsvlio"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "241.01 257.6 226.52 252.16 217.6 193.33 222.21 190.35 236.75 192.5 237.22 198.09 238 207.12 238.91 217.94 239.71 233.1 241.01 257.6",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "229.305px 223.975px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "217.6 193.33 222.82 188.17 226.72 190.71 222.95 196.86 217.6 193.33",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "222.16px 192.515px"
    },
    id: "elyya5q05j4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsshjvdnc0tj"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "217.6 193.33 222.82 188.17 226.72 190.71 222.95 196.86 217.6 193.33",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "222.16px 192.515px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.14,193c-2,3.62-5.63,63.51-5.63,63.51l-7.57,0s-3-57.53,1.32-62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "199.033px 224.755px"
    },
    id: "el8dc32zvgm8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsw0uvlsznxo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.14,193c-2,3.62-5.63,63.51-5.63,63.51l-7.57,0s-3-57.53,1.32-62Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "199.033px 224.755px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "207.56 189.9 202.85 193.37 202.96 196.72 207.02 193.11 207.56 189.9",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "205.205px 193.31px"
    },
    id: "elbejtuf3g839",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc6dec829hbh"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "207.56 189.9 202.85 193.37 202.96 196.72 207.02 193.11 207.56 189.9",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      isolation: "isolate",
      transformOrigin: "205.205px 193.31px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el17rwlklv4x9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238,207.12l.92,10.82c-3.85-5.38-2.77-14.16-2.77-14.16S236.93,205.15,238,207.12Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "237.465px 210.86px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.55,163.55c3.08,1.61,2.16,5-3.73,10.94-3-3.11-4.21-9.68-2.31-11.59S203.87,162.15,206.55,163.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.937px 168.194px"
    },
    id: "el5o01hixhk8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.46,167.48c.49,7,1.12,11.11-1.92,15.15-4.59,6.08-13.61,4-16.19-2.73-2.31-6.06-2.72-16.54,3.74-20.2a9.6,9.6,0,0,1,13.11,3.55A9.42,9.42,0,0,1,219.46,167.48Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "209.84px 172.33px"
    },
    id: "elo6uy9qn6md8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,170.76c.08.56-.16,1.06-.54,1.11s-.72-.37-.79-.94.16-1.06.52-1.12S209.19,170.2,209.3,170.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.636px 170.839px"
    },
    id: "elh8jxa2i7wnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.85,171.61c.08.57-.16,1.07-.53,1.11s-.74-.36-.81-.94.16-1.06.53-1.11S202.78,171,202.85,171.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.181px 171.694px"
    },
    id: "elvc0u2iphr5q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,171.6a20.39,20.39,0,0,1-2.07,5.21,3.31,3.31,0,0,0,2.78.15Z",
    style: {
      fill: "rgb(213, 135, 69)",
      transformOrigin: "204.32px 174.398px"
    },
    id: "elrbgdmgddhdf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.8,168.49a.4.4,0,0,0,.21-.07.35.35,0,0,0,0-.48,3.36,3.36,0,0,0-2.9-1,.32.32,0,0,0-.27.37v0a.34.34,0,0,0,.39.27h0a2.64,2.64,0,0,1,2.28.83A.36.36,0,0,0,210.8,168.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.47px 167.7px"
    },
    id: "elmuv9yj47zvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.63,169.82a.35.35,0,0,0,.28-.23,2.67,2.67,0,0,1,1.68-1.75.34.34,0,0,0,.24-.42.35.35,0,0,0-.41-.24,3.36,3.36,0,0,0-2.14,2.2.33.33,0,0,0,.2.42h0A.34.34,0,0,0,199.63,169.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.552px 168.497px"
    },
    id: "elkcjhd3w160e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,161.66c-3.12,1.55-2.26,5,3.51,11,3.08-3,4.41-9.6,2.54-11.53S218.6,160.32,215.88,161.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.444px 166.378px"
    },
    id: "ellq98z8rr2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.52,172.62a6.77,6.77,0,0,1-2.64,4.39c-1.9,1.37-3.66-.13-3.82-2.35-.14-2,.69-5.12,2.92-5.62A3,3,0,0,1,223.52,172.62Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "220.317px 173.256px"
    },
    id: "ela6ayaesttui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.45,160.71s.86-2.65-3.78-5.67-12.73-1.56-18.2,1.68.35,8.48,2.83,8.81l-.62-.92a18.59,18.59,0,0,0,7.95-.62l-1.54-.67S218.18,162.41,221.45,160.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.357px 159.46px"
    },
    id: "elmv1qcz9e80k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.72,178.57a16.74,16.74,0,0,1,1.06,2.3l.44-.09c2-.43,2.75-1.28,3-2.09a2.64,2.64,0,0,0,.07-1.23,2.55,2.55,0,0,0-.21-.68,9.56,9.56,0,0,1-3.7,1.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.026px 178.825px"
    },
    id: "elrtdwzpizzzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,178.42l.33.66c1.86-.4,3.12-.93,3.58-1.62a2.55,2.55,0,0,0-.21-.68A9.56,9.56,0,0,1,207.39,178.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.345px 177.93px"
    },
    id: "el275662ftkre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.22,180.78c2-.43,2.75-1.28,3-2.09a6.7,6.7,0,0,0-2.1.9A2.48,2.48,0,0,0,208.22,180.78Z",
    style: {
      fill: "rgb(162, 78, 63)",
      transformOrigin: "209.72px 179.735px"
    },
    id: "el489vjsfyqid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.57,202.27c1.42,2.37,2.65,4.6,3.88,6.95s2.35,4.72,3.42,7.18a67.56,67.56,0,0,1,2.87,7.67,43.07,43.07,0,0,1,1,4.24,22.81,22.81,0,0,1,.41,4.93v.15a4.05,4.05,0,0,1-.12.85,26.14,26.14,0,0,1-1.75,4.71c-.68,1.41-1.41,2.72-2.17,4a86.06,86.06,0,0,1-4.87,7.1c-1.71,2.24-3.51,4.38-5.35,6.46-.94,1-1.88,2.05-2.84,3.06l-1.45,1.5-.74.75c-.23.27-.51.47-1.28.27a6.56,6.56,0,0,1-4.33-3.6l-.31-.68c-.32-.7-.14-1,.08-1.23l.61-.77,1.22-1.56q1.2-1.57,2.37-3.18c1.58-2.1,3.1-4.25,4.56-6.4a75,75,0,0,0,4-6.5,24.9,24.9,0,0,0,2.5-6.16l-.12,1a20.23,20.23,0,0,0-1.34-5.7c-.76-2.12-1.71-4.28-2.74-6.44s-2.18-4.29-3.36-6.42-2.44-4.28-3.68-6.23l0-.06a5.59,5.59,0,0,1,9.44-6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.462px 230.869px"
    },
    id: "ellepsa9rk8k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el503lsbwwz02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.71,233.1c-6.84-6.58-10.4-19.79-10.4-19.79.58-5,3.79-11.16,7.91-15.22l.78,9,.91,10.82Z",
    style: {
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "234.51px 215.595px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.75,192.5c4.63,1.36,14.45,23.29,14.45,23.29l-13.75,10.06-8.14-12.54s-2.25-9.31,0-15A8.72,8.72,0,0,1,236.75,192.5Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "239.755px 209.175px"
    },
    id: "el6m8ykked60o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5x9d5pnn18s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.75,192.5c4.63,1.36,14.45,23.29,14.45,23.29l-13.75,10.06-8.14-12.54s-2.25-9.31,0-15A8.72,8.72,0,0,1,236.75,192.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      isolation: "isolate",
      transformOrigin: "239.755px 209.175px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.82,206.67l-.43-7.79,8,3.29s0,7-3.63,6.82Z",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "170.39px 203.937px"
    },
    id: "elbpcnd9l264a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.04 192.06 175.96 197.23 174.4 202.18 166.39 198.88 170.04 192.06",
    style: {
      fill: "rgb(235, 179, 118)",
      transformOrigin: "171.175px 197.12px"
    },
    id: "elf82my8eioa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.31,254s6,4.11,7.69,10.16l-7.69,10.22S222.08,261.4,228.31,254Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.771px 264.19px"
    },
    id: "elqlqkus8bu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt3agh8t0ikd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.31,254s6,4.11,7.69,10.16l-7.69,10.22S222.08,261.4,228.31,254Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      isolation: "isolate",
      transformOrigin: "230.771px 264.19px"
    },
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.b6b5ebd552ec453c6e77515d8729fec8.svg";
export { ForwardRef as ReactComponent };